import { ExpressionRule, CallbackRule } from './Rules';
import { RuleSeverity } from './ValidationState';
var ValidationRules = /** @class */ (function () {
    function ValidationRules() {
        this.rules = [];
    }
    /**
     * Registers a custom rule.
     * NOTE: Do not use an arrow function: add(context => {}), either pass in the address of a function: add(this.myRule), or pass an anonymous function: add(function(context) {}).
     * @param ruleFunction
     */
    ValidationRules.prototype.add = function (ruleFunction) {
        var rule = new CallbackRule(ruleFunction);
        this.rules.push(rule);
        return rule;
    };
    ValidationRules.prototype.failWhen = function (check, errorText) {
        var rule = new ExpressionRule(check, errorText, RuleSeverity.Error);
        this.rules.push(rule);
        return rule;
    };
    ValidationRules.prototype.warnWhen = function (check, warningText) {
        var rule = new ExpressionRule(check, warningText, RuleSeverity.Warning);
        this.rules.push(rule);
        return rule;
    };
    ValidationRules.prototype.infoWhen = function (check, infoText) {
        var rule = new ExpressionRule(check, infoText, RuleSeverity.Info);
        this.rules.push(rule);
        return rule;
    };
    return ValidationRules;
}());
export { ValidationRules };
